import { gql } from '__generated__'

export const GetCandidateEducationOptions = gql(/* GraphQL */ `
    query GetCandidateEducationOptions {
        degreeTypes {
            id
            value
        }
        colleges {
            id
            value
        }
        mbaColleges {
            id
            value
        }
        majors {
            id
            value
        }
        programs {
            id
            value
        }
    }
`)

export const GetCandidateNamesByRecentlyViewed = gql(/* GraphQL */ `
    query GetCandidateNamesByRecentlyViewed(
        $page: Int!
        $limit: Int!
        $searches: SearchObject
    ) {
        candidatesByRecentlyViewed(
            page: $page
            limit: $limit
            searches: $searches
        ) {
            pageInfo {
                pageTotal
                pageNumber
                itemTotal
            }
            data {
                id
                user {
                    id
                    firstName
                    nickname
                    lastName
                }
            }
        }
    }
`)

export const GetCandidatesByRecentlyViewed = gql(/* GraphQL */ `
    query GetCandidatesByRecentlyViewed(
        $page: Int!
        $limit: Int!
        $searches: SearchObject
    ) {
        candidatesByRecentlyViewed(
            page: $page
            limit: $limit
            searches: $searches
        ) {
            pageInfo {
                pageTotal
                pageNumber
                itemTotal
            }
            data {
                id
                lastViewed
                recruitingStatus {
                    status
                }
                documents {
                    id
                    documentType
                    documentKey
                }
                recruiterStarRating
                city
                country {
                    value
                }
                state {
                    value
                }
                province {
                    value
                }
                internalProfileImageKey
                user {
                    nickname
                    firstName
                    lastName
                    profileImageKey
                }
                workExperience {
                    isCurrent
                    industries {
                        topTier
                        industry {
                            id
                            value
                        }
                    }
                    sectors {
                        topTier
                        sector {
                            id
                            value
                        }
                    }
                    company {
                        value
                    }
                    title {
                        isStudent
                    }
                }
                education {
                    graduationDate
                    college {
                        value
                    }
                    degrees {
                        value
                    }
                    majors {
                        major {
                            value
                            id
                        }
                    }
                }
            }
        }
    }
`)

export const AddCandidate = gql(/* GraphQL */ `
    mutation AddCandidate(
        $sendInvitationEmail: Boolean
        $education: EducationEntry
        $workExperience: AddWorkExperienceInput
        $prefersWorkEmail: Boolean
        $profile: CandidateProfileEntry
    ) {
        addCandidate(
            sendInvitationEmail: $sendInvitationEmail
            education: $education
            workExperience: $workExperience
            prefersWorkEmail: $prefersWorkEmail
            profile: $profile
        ) {
            success
            message
        }
    }
`)
